module.exports = "https://static.wmbcdn.com/uniweb/images/d12f5f0ed6786d595dbc4304ab696ef1.svg";